import { render, staticRenderFns } from "./BarrierLogPopup.vue?vue&type=template&id=6dacce46&scoped=true"
import script from "./BarrierLogPopup.vue?vue&type=script&lang=ts"
export * from "./BarrierLogPopup.vue?vue&type=script&lang=ts"
import style0 from "./BarrierLogPopup.vue?vue&type=style&index=0&id=6dacce46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dacce46",
  null
  
)

export default component.exports